module.exports = __webpack_public_path__ + "static/img/doc.bf7d4b12.png";